import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const LayoutContext = createContext({ header: null, footer: null });

export function LayoutProvider({ children }) {
  const [layout, setLayout] = useState({ header: null, footer: null });
  useEffect(() => {
    api.get("/cms/layout").then((r) => setLayout(r.data || {})).catch(() => setLayout({ header: null, footer: null }));
  }, []);
  return <LayoutContext.Provider value={layout}>{children}</LayoutContext.Provider>;
}

export function useLayout() {
  return useContext(LayoutContext) || { header: null, footer: null };
}

// Built-in fallbacks: keep the exact current design when no published CMS layout is available.
export const HEADER_FALLBACK = {
  show_brand: true,
  nav_links: [
    { label: "Home", href: "/" },
    { label: "Destinations", href: "/destinations" },
    { label: "Experiences", href: "/experiences" },
    { label: "Sample Itineraries", href: "/itineraries" },
    { label: "Partner With Us", href: "/partner", children: [
      { name: "Register as a Travel Partner", label: "Register as a Travel Partner", href: "/partner", order: 0, active: true, new_tab: false },
      { name: "Register as a Service Provider", label: "Register as a Service Provider", href: "/service-provider-registration", order: 1, active: true, new_tab: false },
    ] },
    { label: "About Us", href: "/about" },
    { label: "Contact", href: "/contact" },
  ],
  cta: { label: "Send Your Query", href: "/enquiry", enabled: true },
};

export const FOOTER_FALLBACK = {
  tagline: "Maharashtra's premium B2B destination management partner, helping travel professionals craft memorable journeys through local expertise and reliable ground operations.",
  columns: [
    { title: "Quick Links", links: [
      { label: "Destinations", href: "/destinations" },
      { label: "Experiences", href: "/experiences" },
      { label: "Sample Itineraries", href: "/itineraries" },
      { label: "About Us", href: "/about" },
      { label: "Send Your Query", href: "/enquiry" },
      { label: "Register as Partner", href: "/partner" },
    ] },
    { title: "Regions", links: [
      { label: "Konkan Coast", href: "/destinations/konkan-coast" },
      { label: "Pune & Sahyadris", href: "/destinations/pune-and-sahyadris" },
      { label: "Vidarbha & Wildlife", href: "/destinations/vidarbha-wildlife" },
      { label: "Spiritual Maharashtra", href: "/destinations/spiritual-maharashtra" },
      { label: "Ajanta & Ellora", href: "/destinations/sambhajinagar-marathwada" },
    ] },
  ],
  show_contact: true,
  show_social: true,
  legal_links: [
    { label: "Privacy Policy", href: "/privacy-policy" },
    { label: "Terms of Use", href: "/terms-of-use" },
    { label: "Disclaimer", href: "/disclaimer" },
    { label: "Payment & Cancellation Policy", href: "/payment-cancellation-policy" },
  ],
  disclosure: "Maha Sampada is an initiative of Turekar Global Private Limited and operates as an independent private tourism platform. It is not affiliated with or operated by the Government of Maharashtra.",
  copyright: "© {year} Maha Sampada. All rights reserved.",
};

// Renders an internal path with <Link> and external/other schemes with <a>.
export function isInternal(href) {
  return typeof href === "string" && href.startsWith("/");
}
